import React from "react";
import { useForm } from 'react-final-form';

import { Create } from 'react-admin';
import { Show } from 'react-admin';
import { Edit } from 'react-admin';
import { useRecordContext } from 'react-admin';
import { SimpleShowLayout, TextField, DateField, RichTextField, ReferenceManyField, Button, Datagrid } from 'react-admin';
import { SimpleForm, TextInput, DateInput, EditButton, required } from 'react-admin';

import App from '../../../../app.js';

const PrivateKeyInput = (props) => {
	const theapp = App.getAppObject();
	const form = useForm();

	const onPrivateKeyChange = async () => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		const formdata = form.getState().values;
		let private_key = formdata.private_key;

		let public_keys = await mvcmydashboard.getPublicKeys(sessionuuid, private_key );
		form.change('address', public_keys['address']);
	}

	return (
		<TextInput source="private_key" onChange={onPrivateKeyChange}/>
	);

};

const GenerateButton = (props) => {
	const theapp = App.getAppObject();
	const form = useForm();

	const generatePrivateKey = async () => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		let sessionuuid = await mvcmydashboard.getCurrentSession();
		let private_key = await mvcmydashboard.generatePrivateKey(sessionuuid);

		let public_keys = await mvcmydashboard.getPublicKeys(sessionuuid, private_key );

		form.change('private_key', private_key);
		form.change('address', public_keys['address']);
	}

	return (
		<Button label="Generate Private Key" onClick={generatePrivateKey} />
	);

};

export const AccountCreate = (props) => (
	<Create title='Create Ethereum Account' {...props}>
		<SimpleForm>
			<TextInput source="description" validate={[required()]}  />
			<TextInput source="address" validate={[required()]}  />
			<PrivateKeyInput />
			<GenerateButton />

		</SimpleForm>
	</Create>
);

export const AccountShow = (props) => (
	<Show title='Ethereum Account' {...props}>
		<SimpleShowLayout>
			<TextField source="description" />
			<TextField source="uuid" />
			<TextField source="type" />
			<TextField source="address" />
			<TextField source="public_key" />
			<TextField source="rsa_public_key" />
		</SimpleShowLayout>
	</Show>
);

export const AccountEdit = (props) => (
	<Edit title='Modify Ethereum Account' {...props}>
		<SimpleForm>
			<TextInput source="description" />
			<TextField source="uuid" />
			<TextField source="type" />
			<TextField source="address" />
			<TextField source="public_key" />
			<TextField source="rsa_public_key" />
		</SimpleForm>
	</Edit>
);



